function Studio(axios, baseUrl) {

    this.axios = axios;
    this.baseUrl = `${baseUrl}studio`;

    this.get = function (id) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/${id}`);
    }
    this.getAll = function () {
        let self = this;
        return self.axios.get(`${self.baseUrl}`);
    }
    this.getForDropdown = function () {
        let self = this;
        return self.axios.get(`${self.baseUrl}/GetForDropdown`);
    }
    this.getByListIndex = function (index) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/getByListIndex/${index}`);
    }
    this.DDItemsCount = function () {
        let self = this;
        return self.axios.get(`${self.baseUrl}/GetDropdownItemsCount`);
    }
    this.add = function (model) {
        let self = this;
        return self.axios.post(`${self.baseUrl}`, model);
    }
    this.update = function (model) {
        let self = this;
        return self.axios.put(`${self.baseUrl}`, model);
    }
    this.filterByName = function (name) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/filterByName/${name}`);
    }
    this.remove = function (id) {
        let self = this;
        return self.axios.delete(`${self.baseUrl}/${id}`);
    }
}

export default Studio;
